import React from 'react';
import TopNav from '../../components/TopNav';
import Footer from '../../components/Footer';
import CatchImage from '../../images/catch/catch_privacy.jpg';
import CatchImage2x from '../../images/catch/catch_privacy@2x.jpg';
import { useTitle } from '../../hooks/useTitle';
import { useMetaDescription } from '../../hooks/useMetaDescription';

const CookiePolicy: React.FC = () => {
  useTitle('Ton Bébé | クッキーポリシー');
  useMetaDescription('Ton Bébéのクッキーポリシーです。本サービスにおけるクッキー等の使用目的および管理方法について説明します。');

  return (
    <>
      <header>
        <TopNav />
        <div className="catch sub">
          <img
            src={ CatchImage }
            srcSet={ `${ CatchImage } 1x, ${ CatchImage2x } 2x` }
            alt="クッキーポリシー"
          />
        </div>
      </header>
      <main className="sub">
        <section className="privacy">
          <h1 className="sec_title">クッキーポリシー</h1>
          <ul className="text_list">
            <li>
              <h2 className="main_title"><span>Ton Bébé クッキーポリシー</span></h2>
              <p>
                Ton Bébé（以下、「当社」といいます。）は、本ウェブサイト上で提供するサービス（以下、「本サービス」といいます。）において、クッキー（Cookie）およびこれに類する技術を使用しています。本ポリシーでは、これらの技術の使用目的および管理方法について説明します。
              </p>
            </li>
            <li>
              <h2 className="main_title"><span>第1条（クッキーとは）</span></h2>
              <p>
                クッキーとは、ウェブサイトを訪問した際に、ウェブサイトからユーザーのコンピュータやスマートフォン等のデバイスのブラウザに送信され、保存される小さなテキストファイルです。クッキーには、ウェブサイトの設定情報やユーザーの識別情報などが記録されます。
              </p>
            </li>
            <li>
              <h2 className="main_title"><span>第2条（クッキーの使用目的）</span></h2>
              <p>当社は、以下の目的でクッキーを使用します。</p>
              <ul className="box">
                <li>（1）ユーザーの認証状態を維持し、スムーズなサービス利用を実現するため</li>
                <li>（2）ユーザーの設定や選択を記憶し、利便性の高いサービスを提供するため</li>
                <li>（3）本サービスの利用状況を分析し、サービスの改善および最適化を図るため</li>
                <li>（4）ユーザーの興味や関心に基づいた情報やコンテンツを提供するため</li>
                <li>（5）セキュリティの維持および不正利用の防止のため</li>
                <li>（6）広告の配信および効果測定のため</li>
              </ul>
            </li>
            <li>
              <h2 className="main_title"><span>第3条（クッキーの種類）</span></h2>
              <p>当社が使用するクッキーには、以下の種類があります。</p>
              <ul className="box">
                <li>
                  （1）必須クッキー<br />
                  本サービスの基本的な機能を提供するために必要不可欠なクッキーです。これらのクッキーを無効にすると、本サービスの一部機能が正常に動作しない可能性があります。
                </li>
                <li>
                  （2）機能性クッキー<br />
                  ユーザーの選択や設定を記憶し、より快適なサービス利用を実現するためのクッキーです。
                </li>
                <li>
                  （3）分析クッキー<br />
                  本サービスの利用状況を分析し、サービスの改善に役立てるためのクッキーです。Google Analyticsなどの第三者の分析ツールが含まれます。
                </li>
                <li>
                  （4）広告クッキー<br />
                  ユーザーの興味や関心に基づいた広告を配信するためのクッキーです。
                </li>
              </ul>
            </li>
            <li>
              <h2 className="main_title"><span>第4条（第三者によるクッキーの使用）</span></h2>
              <p>
                当社は、本サービスの改善および広告配信の最適化のため、以下のような第三者サービスを利用しており、これらのサービスがクッキーを使用する場合があります。
              </p>
              <ul className="box">
                <li>（1）Google Analytics（アクセス解析）</li>
                <li>（2）Google AdSense（広告配信および効果測定）</li>
                <li>（3）Stripe（決済処理の不正防止）</li>
                <li>（4）その他のサービス事業者</li>
              </ul>
              <p>
                これらの第三者サービスによるクッキーの使用については、各事業者のプライバシーポリシーをご確認ください。
              </p>
            </li>
            <li>
              <h2 className="main_title"><span>第5条（クッキーの管理）</span></h2>
              <p>
                ユーザーは、ブラウザの設定により、クッキーの受け入れを拒否したり、クッキーを削除したりすることができます。ただし、クッキーを無効にした場合、本サービスの一部機能が利用できなくなる可能性がありますので、あらかじめご了承ください。
              </p>
              <p>主要なブラウザにおけるクッキーの設定方法については、各ブラウザの提供元にお問い合わせください。</p>
            </li>
            <li>
              <h2 className="main_title"><span>第6条（同意の撤回）</span></h2>
              <p>
                ユーザーは、クッキーの使用に対する同意をいつでも撤回することができます。同意を撤回する場合は、ブラウザの設定からクッキーを削除し、クッキーの受け入れを拒否してください。
              </p>
            </li>
            <li>
              <h2 className="main_title"><span>第7条（クッキーポリシーの変更）</span></h2>
              <p>
                1. 当社は、法令の改正やサービス内容の変更等により、本ポリシーを変更することがあります。変更後のクッキーポリシーは、本ウェブサイトに掲載した時点より効力を生じるものとします。
              </p>
              <p>
                2. 重要な変更がある場合には、本ウェブサイト上で事前にお知らせいたします。
              </p>
            </li>
            <li>
              <h2 className="main_title"><span>第8条（お問い合わせ窓口）</span></h2>
              <p>本ポリシーに関するお問い合わせは、下記の窓口までお願いいたします。<br />info@tonbebe.jp</p>
            </li>
          </ul>
          <p className="right">令和7年12月1日 制定</p>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default CookiePolicy;
